import moment from 'moment-timezone';

export var rentalReducer = (state = null, action) => {
	switch(action.type) {
		case "RESTORE_RENTAL" : 
			if (state && state.id === action.id) {
            return null;
			}
			return state;
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/rentalReducer.js